import axiosIns from '@/api/axios';

export const GET_ALL_DATA = (args) => {
	return axiosIns.get('/organizations?' + args);
};

export const GET_DETAIL = (args) => {
	return axiosIns.get(`/organizations/${args.id}`);
};

export const ADD_DATA = (args) => {
	return axiosIns.post('/organizations', args);
};

export const UPDATE_DATA = (args) => {
	return axiosIns.put(`/organizations/${args.id}`, args);
};

export const DELETE_DATA = (id) => {
	return axiosIns.delete(`/organizations/${id}`);
};
